import styled from 'styled-components';

export const AlertHistoryContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 0px 32px 32px 32px;
`;
